import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import { redirect } from '@/helpers/redirects';
import { checkJwtRoles } from './helpers';

/**
 * Guard for external review routes that allows unauthenticated access
 * but redirects authenticated users appropriately:
 * - Unauthenticated users: allowed (for external review flow)
 * - Authenticated sitters: redirected to provider dashboard
 * - Authenticated parents: redirected to sitter profile
 */
const externalReviewGuard = (to: Route, _from: Route, next: NavigationGuardNext) => {
  const account = store.getters['account/getAccount'];

  if (!account || typeof account.isParent !== 'function') {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      // Unauthenticated - allow access (different from requireSeeker which redirects to login)
      next();
      return;
    }

    if (jwtCheck.isSitter) {
      // Sitter - redirect to dashboard (same as requireSeeker)
      next(false);
      redirect('/account/providers/dashboard');
      return;
    }

    if (jwtCheck.isParent) {
      // Parent - redirect to sitter profile (different from requireSeeker which allows)
      next(false);
      redirect(`/providers/${to.params.sitterId}`);
      return;
    }

    // Fallback: allow access
    next();
    return;
  }

  // Account methods available - use same checking logic as requireSeeker
  if (account.isSitter()) {
    // Sitter - redirect to dashboard (same as requireSeeker)
    next(false);
    redirect('/account/providers/dashboard');
    return;
  }

  if (account.isParent()) {
    // Parent - redirect to sitter profile (different from requireSeeker which allows)
    next(false);
    redirect(`/providers/${to.params.sitterId}`);
    return;
  }

  // Fallback: allow access
  next();
};

export default externalReviewGuard;
